import { z } from 'zod';
/**
 * Ghi chú bộ nhớ AI — APM-H-j (`plan-harness.md` §6.2; deer-flow §4.3).
 *
 * Sự thật bền do **người dùng xác nhận** giữ lại ("đội làm 4 ngày một tuần"),
 * rút từ câu trả lời hỏi lại hoặc từ lý do từ chối gợi ý. Không có ghi nhớ ngầm:
 * AI chỉ đề xuất, người bấm mới lưu.
 */
export const MemoryScope = z.enum(['user', 'project', 'org']);
/** `temporary` hết hạn sau 30 ngày. */
export const MemoryDurability = z.enum(['durable', 'temporary']);
/**
 * Enum **một giá trị**, có chủ đích. "PM đã đồng ý dời deadline sprint 4" là uỷ
 * quyền một lần; để nó vào bộ nhớ là để model tin PM luôn đồng ý. Không có giá
 * trị `transactional` trong schema nghĩa là không có đường để nó vào — kể cả qua admin.
 */
export const MemoryAuthority = z.literal('descriptive');
/** Ghi chú sinh từ đâu — `rejection` có ngân sách riêng khi chèn vào prompt. */
export const MemoryOrigin = z.enum(['manual', 'answer', 'rejection']);
export const MEMORY_TEMPORARY_DAYS = 30;
export const AiMemoryNote = z.object({
    id: z.uuid(),
    scope: MemoryScope,
    /** Project id hay user id theo `scope`; `null` cho `org`. */
    scopeId: z.uuid().nullable(),
    text: z.string(),
    durability: MemoryDurability,
    authority: MemoryAuthority,
    origin: MemoryOrigin,
    sourceRunId: z.uuid().nullable(),
    createdBy: z.uuid(),
    createdAt: z.iso.datetime(),
    expiresAt: z.iso.datetime().nullable(),
    /** Tăng khi PM duyệt một gợi ý mà run của nó đã chèn ghi chú này, hoặc bấm "vẫn đúng". */
    confirmations: z.number().int().nonnegative(),
    lastConfirmedAt: z.iso.datetime().nullable(),
});
export const CreateMemoryNoteInput = z.object({
    scope: MemoryScope,
    /** Bắt buộc với `project`; bỏ trống với `user` (= chính mình) và `org`. */
    scopeId: z.uuid().optional(),
    text: z.string().trim().min(5).max(500),
    durability: MemoryDurability.default('durable'),
    authority: MemoryAuthority.default('descriptive'),
    origin: MemoryOrigin.default('manual'),
    sourceRunId: z.uuid().optional(),
});
/**
 * Câu để nhớ do **skill đề xuất** trong output (`memoryNotes[]`) — người bấm mới
 * lưu. Thiếu một trong ba nhãn ⇒ loại **mục đó** vào `verify.rejected`, không loại lô.
 */
export const MemoryNoteProposal = z.object({
    text: z.string().trim().min(5).max(500),
    scope: MemoryScope,
    durability: MemoryDurability,
    authority: MemoryAuthority,
});
export const ListMemoryNotesQuery = z.object({
    scope: MemoryScope,
    scopeId: z.uuid().optional(),
});
//# sourceMappingURL=ai-memory.js.map